import * as React from "react";
import { Props as MenuItemProps } from "./appMenuItem";

export type MenuItemElement = React.ReactElement<MenuItemProps>;

export type MenuItemListType = ReturnType<typeof getMenuItemsOfType>;
export const getMenuItemsOfType = (
    type: string,
    _children: React.ReactNode,
    _isOpen: boolean,
    onClick: (item: { id?: string; route?: string }) => void
) =>
    React.Children.toArray(_children)
        .filter((child: MenuItemElement) => child && child.props.type === type)
        .map((child: MenuItemElement, i) =>
            React.cloneElement(child, {
                key: i,
                isOpen: _isOpen,
                onClick: onClick,
            })
        );
